// TODO: Remove TileItem with old design and replace
import { memo, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { formatDuration } from "@/common/utils/parseNumber";
import { Image } from "components";
import { clsx } from "clsx";
import { ViewButton, ViewButtonType } from "components/buttons/ViewButton";
import CarouselIcon from "./images/icons/carousel.svg?react";
import "./GifTile.scss";
import { metricsBus, EventSource } from "@/common/buses";
import { VerifiedIcon } from "components/UI/VerifiedIcon";
import { IUser } from "@/common/services/types";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

interface IGifTile {
  thumbnail: string;
  imageAlt: string;
  video: string | undefined;
  verified: boolean;
  link: string;
  views: number;
  duration: number;
  gallery: boolean;
  index: number;
  isVertical?: boolean;
  user?: IUser;
  onTileClick?: () => void;
}

export const GifTile: React.FC<IGifTile> = memo(({
  video,
  gallery,
  index,
  duration,
  verified,
  imageAlt,
  thumbnail,
  views,
  link,
  isVertical,
  user,
  onTileClick,
}) => {
  const [isHover, setHover] = useState<boolean>(false);
  const eventSource = useAnalyticsStore((state) => state.eventSource);

  // TODO: later implement manage functionality for new gif tile component
  const onLinkClick = useCallback(() => {
    metricsBus.emit("gifClicked", { position: index, source: eventSource?.name ?? EventSource.Other });
    onTileClick?.();
  }, [index, eventSource, onTileClick]);

  const handleMouseEnter = useCallback(() => setHover(true), []);
  const handleMouseLeave = useCallback(() => setHover(false), []);

  const isVideoAvailable = isHover && Boolean(video);

  return (
    <Link
      to={link}
      className={clsx({
        "GifTile": true,
        "GifTile_isImage": !video,
        "GifTile_isVertical": isVertical,
        "GifTile_isVideo": !!video,
      })}
      onClick={onLinkClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Image
        className="GifTile-Thumbnail"
        alt={imageAlt}
        src={thumbnail}
      />

      {isVideoAvailable && (
        <video
          className={clsx({
            "GifTile-Video": true,
            "GifTile-Video_isReady": isVideoAvailable,
          })}
          data-testid="player"
          autoPlay
          loop
          playsInline
          preload="auto"
          muted
        >
          <source src={video} type="video/mp4" />
        </video>
      )}

      {views > 0 && (
        <div className="GifTile-Views">
          <ViewButton type={video ? ViewButtonType.VIDEO : ViewButtonType.IMAGE} count={views} />
        </div>
      )}

      {duration && (
        <div className="GifTile-Duration">
          {formatDuration(duration)}
        </div>
      )}

      {gallery && (
        <div className="GifTile-GalleryIcon">
          <CarouselIcon />
        </div>
      )}

      {verified && (
        <VerifiedIcon title={`Gif from a verified ${user?.studio ? "studio" : "user"}`} isStudio={user?.studio} />
      )}
    </Link>
  );
});
